import { render, staticRenderFns } from "./cms_regi.vue?vue&type=template&id=1ec2e7dd&"
import script from "./cms_regi.vue?vue&type=script&lang=js&"
export * from "./cms_regi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports